var modules_192c04a7 = {"container":"Copyrights_module_container__00b322d8"};
import "../../../assets/Bws764uc.css";

export { modules_192c04a7 as default };
//# sourceMappingURL=Copyrights.module.less.js.map
